import * as React from 'react';
import Theme from '../../../styles/Theme/Theme';
//import * as IconsLibrary from '../../../assets/icons/_index';
import * as IconsLibrary from './Library';


const CustomIcon = ({ icon, ...rest }) => {
    if (icon) {
        const windowSize = window.screen.width;
        let size;
        if (windowSize >= Theme.deviceValue.videowall) {
            size = Theme.icons.videowall[rest.iconSize]
        } else if (windowSize >= Theme.deviceValue.desktop) {
            size = Theme.icons.desktop[rest.iconSize]
        } else if (windowSize >= Theme.deviceValue.laptop) {
            size = Theme.icons.laptop[rest.iconSize]
        } else if (windowSize >= Theme.deviceValue.tablet) {
            size = Theme.icons.tablet[rest.iconSize]
        } else {//(windowSize < '480px')
            size = Theme.icons.mobile[rest.iconSize]
        }

        let Component = IconsLibrary[icon];
        if (Component && typeof Component !== 'undefined') {
            return <Component {...rest} size={size} />;
        }

        console.error('ERROR: SVG icon (' + icon + ') does not exist');
        return null;
    }

    console.error('ERROR: icon props is missing');
    return null;
};

export default CustomIcon;
